module.exports = __webpack_public_path__ + "media/video4.be5fd0b0.mp4";